const sessionKey = "jeet11:session";

export const createSessionStore = () => {
	if (sessionStorage) {
		try {
			sessionStorage.setItem(sessionKey, JSON.stringify({}));
		} catch (e) {
			console.log(e);
		}
	}
};

export const loadSessionState = () => {
	if (typeof window === "undefined" || !sessionStorage) {
		return {};
	}

	try {
		const session = JSON.parse(sessionStorage[sessionKey]);
		return session;
	} catch {
		createSessionStore();
		return {};
	}
};

export const getSessionItem = key => {
	try {
		const jeet11SessionStorage = loadSessionState();
		return jeet11SessionStorage[key];
	} catch (e) {
		return undefined;
	}
};

export const setItemForSession = (key, value) => {
	const jeet11SessionStorage = loadSessionState();
	jeet11SessionStorage[key] = value;
	saveState(jeet11SessionStorage);
};

export const saveState = state => {
	try {
		sessionStorage.removeItem(sessionKey);
		sessionStorage.setItem(sessionKey, JSON.stringify(state));
	} catch (e) {
		console.log(e);
	}
};
